<template>
  <div>
    
    <span 
      v-if="type_movement_id == 1"
      class=" flex bg-tuin_hover text-white justify-center items-center text-sm font-semibold rounded-md px-3 py-1 z-50  ml-2"
    >
      {{ label }}
    </span>

    <span  
      v-if="type_movement_id == 2"
      class=" flex bg-tuin_hover text-white justify-center items-center
      text-sm font-semibold rounded-md px-3 py-1 z-50  ml-2"
    >
    
      {{ label }}
    </span>

    <span  
      v-if="type_movement_id == 3"
      class="flex bg-tuin_hover text-white justify-center items-center 
      text-sm font-semibold rounded-md px-3 py-1 z-50  ml-2 whitespace-nowrap"
    >
    
      {{ label }}
    </span>

    <span  
      v-if="type_movement_id == 4"
      class=" flex bg-tuin_hover text-white justify-center items-center
      text-sm font-semibold rounded-md px-3 py-1 z-50  ml-2"
    >
    
      {{ label }}
    </span>

    <span  
      v-if="type_movement_id == 5"
      class=" flex bg-tuin_hover text-white justify-center items-center
      text-sm font-semibold rounded-md px-3 py-1 z-50  ml-2"
    >
    
      {{ label }}
    </span>
    
  </div>   
</template>
  
  <script>
  export default {
    props: {
      label: {
        type: String,
        required: true,
      },
      type_movement_id: {
        type: Number
      }
    },
  };
  </script>
  